import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import ApiExampleView from '@/views/ApiExampleView.vue'
import EditBulkLoadData from '@/views/EditBulkLoadData.vue'
import GroupsView from '@/views/GroupsView.vue'
import DashboardView from '@/onboarding/views/DashboardView.vue'
import RequestAccessLinkView from '@/views/RequestAccessLinkView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: DashboardView,
      children: [
        {
          path: 'dashboard/:groupId',
          name: 'onboarding-dashboard',
          component: DashboardView,
        },
      ],
    },
    {
      path: '/admin',
      name: 'onboarding-request-access-link',
      component: RequestAccessLinkView,
    },
    {
      path: '/groups',
      name: 'groups',
      component: GroupsView,
      meta: { requiresAuth: true },
    },
    {
      path: '/edit-bulk-load-data',
      name: 'edit-bulk-load-data',
      component: EditBulkLoadData,
      meta: { requiresAuth: true },
    },
    // Example API, remove later
    {
      path: '/example',
      name: 'example',
      component: ApiExampleView,
      meta: { requiresAuth: true },
    },
  ],
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  const hasApiKey = localStorage.getItem('apiKey')

  if (requiresAuth && !hasApiKey) {
    next('/')
  } else if (to.name === 'login' && hasApiKey) {
    next('/groups')
  } else {
    next()
  }
})

export default router
